<template>
    <div>
        <div class="field">
            <div class="control">
                <router-link class="button is-success" :to="{'name': 'branch-create'}">Create branch</router-link>
            </div>
        </div>
        <table class="table">
            <tr>
            <th>{{"branches.branch" | translate}}</th>
            <th>{{"branches.description" | translate}}</th>
            <th></th>
            </tr>
            <tr v-for="branch in branches">
            <td>
                <span v-if="isPanicBranch(branch)" class="tag is-danger">{{"branches.branch panic" | translate}}</span>
                <router-link :to="{ name: 'branch-general', params: { branch: branch.branch } }">{{branch.branch}}</router-link>
            </td>
            <td>{{branch.description}}</td>
            <td>
                <a v-if="isPanicBranch(branch)" class="button" @click="panic(branch, false)">{{"branches.no panic" | translate}}</a>
                <a v-else class="button is-danger" @click="panic(branch, true)">{{"branches.panic" | translate}}</a>
            </td>
            </tr>
        </table>
    </div>
</template>
<script>
    import Vue from "vue";

  import branchService from "../../../services/branch.service"

  export default {
    name: 'client-branch-list',
    data() {
      return {
        branches: []
      }
    },
    async mounted() {
      await this.loadBranches();
    },
    methods: {
      async loadBranches() {
        this.branches = await branchService.getByClient();
      },
      async panic(branch, isPanic) {
        let message = isPanic ? this.$t("branches.panic message") : this.$t("branches.no panic message");
        if (!window.confirm(message))
          return;

        branch.settings = branch.settings || {};
        branch.settings.panic = branch.settings.panic || {};
        branch.settings.panic.isPanic = isPanic;
        branch.settings = await branchService.saveSettings(branch.branch, branch.settings);
      },
      isPanicBranch(branch) {
        return branch.settings && branch.settings.panic && branch.settings.panic.isPanic
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/client/branches/list.vue